import { getOwnCustomerSubscriptions, saveCustomerSubscriptions } from "../actions/customerSubscriptions.js";
import { getOwnCustomerWelcomeInfo, saveContactInformation } from "../actions/customer.js";

import AccountSettingsComponent from "../components/AccountSettingsComponent.jsx";
import {connect} from "react-redux";
import {createLocalization} from "../../common/util/localization.jsx";
import { scssVariables } from "../../common/util/config.jsx";
import { validateEmail } from "../../common/util/validators.js";

const mapStateToProps = () => {
    return (state) => ({
        customer: state.customer,
        customerSubscriptions: state.customerSubscriptions,
        deviceType: state.view.deviceType,
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        localization: createLocalization(state),
        signedInAs: state.authentication.signedInAs
    });
};

const mapDispatchToProps = {
    getOwnCustomerSubscriptions,
    getOwnCustomerWelcomeInfo,
    saveContactInformation,
    saveCustomerSubscriptions,
    validateEmail,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});


export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AccountSettingsComponent);